import React from "react";
import { Link } from "react-router-dom";
import DroneIcon from "../components/DroneIcon";

export default function LegalPage({ title, children }) {
  return (
    <div className="min-h-screen bg-[#020617] text-slate-100">
      <nav className="h-16 border-b border-white/5 bg-slate-950/60 backdrop-blur-2xl sticky top-0 z-40">
        <div className="max-w-5xl mx-auto h-full px-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-md bg-gradient-to-br from-[#C29B62] to-[#7a5e34] flex items-center justify-center">
              <DroneIcon size={16} className="text-slate-950" />
            </div>
            <span className="font-display font-black tracking-tight">ProSanalDrone</span>
          </Link>
          <Link to="/" className="text-sm text-slate-400 hover:text-white">← Ana sayfa</Link>
        </div>
      </nav>
      <main className="max-w-4xl mx-auto px-6 py-16 md:py-24">
        <div className="text-xs uppercase tracking-[0.3em] text-[#C29B62] mb-4">Yasal Belge</div>
        <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight mb-10">{title}</h1>
        <div className="prose prose-invert max-w-none text-slate-300 leading-relaxed space-y-5
                        [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-semibold [&_h2]:text-white [&_h2]:mt-10 [&_h2]:mb-3
                        [&_h3]:font-display [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-white [&_h3]:mt-6 [&_h3]:mb-2
                        [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_li]:text-slate-300
                        [&_strong]:text-white">
          {children}
        </div>
        <div className="mt-16 pt-8 border-t border-white/5 text-sm text-slate-500">
          Son güncelleme: {new Date().toLocaleDateString("tr-TR", { year: "numeric", month: "long", day: "numeric" })}
        </div>
      </main>
    </div>
  );
}

export function IadeSartlariPage() {
  return (
    <LegalPage title="İptal ve İade Koşulları">
      <p>
        ProSanalDrone olarak, dijital hizmet (sanal drone videosu üretimi) sunmaktayız.
        Satın alma işleminden sonra geçerli iptal ve iade koşullarımız aşağıda belirtilmiştir.
        6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği çerçevesinde haklarınız saklıdır.
      </p>

      <h2>1. Hizmetin Niteliği</h2>
      <p>
        Platformumuzda satın alınan kredi paketleri (350 TL — Tek Video / 1500 TL — 5'li Paket / 2500 TL — 10'lu Paket),
        kullanıcıya ait hesaba anında yüklenen <strong>dijital hak</strong> niteliğindedir. Her bir kredi,
        bir adet sanal drone videosunun üretimi için harcanır.
      </p>

      <h2>2. Cayma Hakkı</h2>
      <p>
        Mesafeli Sözleşmeler Yönetmeliği'nin 15/1-g maddesi uyarınca, elektronik ortamda <strong>anında ifa edilen
        hizmetler</strong> için tüketicinin cayma hakkı bulunmamaktadır. Kredi paketi satın alındığı anda hesabınıza
        anında yüklendiğinden ve kullanıma hazır hâle geldiğinden, satın alma sonrası cayma hakkı kullanılamaz.
      </p>

      <h3>İade Hakkınızın Doğduğu Haller</h3>
      <ul>
        <li>Ödeme alındıktan sonra teknik bir hata nedeniyle kredinin hesabınıza yüklenmemesi</li>
        <li>Video üretim sürecinde tekrar eden ve çözülemeyen bir sistem hatasının yaşanması</li>
        <li>Hiç kullanılmamış kredilerin yer aldığı paketlerin, satın alma anından itibaren 24 saat içinde iade talebi</li>
      </ul>

      <h2>3. İade Talebi Nasıl Yapılır?</h2>
      <p>
        İade talebinizi aşağıdaki bilgilerle birlikte <strong>destek@prosanaldrone.com</strong> adresine iletebilirsiniz:
      </p>
      <ul>
        <li>Hesabınıza kayıtlı e-posta adresiniz</li>
        <li>Satın alma tarihi ve paket adı</li>
        <li>Ödeme referans numarası (fatura veya iyzico işlem numarası)</li>
        <li>İade talebinizin gerekçesi</li>
      </ul>

      <h2>4. İade Süresi ve Yöntemi</h2>
      <p>
        Kabul edilen iade talepleri, kullanılmamış krediler oranında <strong>14 iş günü içinde</strong>, ödemenin yapıldığı
        karta/hesaba iade edilir. İade işlemi, ödeme sağlayıcısı iyzico üzerinden gerçekleştirilir.
      </p>

      <h3>Kullanılmış Krediler</h3>
      <p>
        Üretim süreci başlatılmış ve/veya tamamlanmış videolar için harcanan krediler, hizmetin ifa edilmesi nedeniyle
        iade kapsamı dışındadır. Video üretimi başarısız olursa (ör. yetersiz sunucu kaynağı), harcanan kredi
        <strong> otomatik olarak hesabınıza iade edilir</strong>.
      </p>

      <h2>5. İletişim</h2>
      <p>
        İptal, iade veya hesap sorularınız için: <strong>destek@prosanaldrone.com</strong>
      </p>
    </LegalPage>
  );
}

export function TeslimatPage() {
  return (
    <LegalPage title="Teslimat ve Hizmet Sunum Koşulları">
      <p>
        ProSanalDrone platformu üzerinden sunulan hizmet <strong>dijital</strong> niteliktedir. Fiziksel bir ürün gönderimi yapılmaz;
        ödeme tamamlandıktan sonra satın alınan kredi paketi hesabınıza anında yüklenir ve video üretim arayüzü
        kullanıma hazır hâle getirilir.
      </p>

      <h2>1. Teslimat Yöntemi</h2>
      <ul>
        <li>Kredi paketleri, ödeme onayının ardından <strong>anında</strong> hesabınıza yüklenir.</li>
        <li>Üretilen her bir video, panelinizdeki <em>Videolarım</em> bölümünden izlenebilir, Full HD olarak indirilebilir ve paylaşılabilir link ile paylaşılabilir.</li>
        <li>Hizmet 7/24 çevrim içidir; teslim süresi için ekstra bir mesai veya kargo takibi gerekmez.</li>
      </ul>

      <h2>2. Video Üretim Süresi</h2>
      <ul>
        <li>Ortalama üretim süresi: <strong>2–5 dakika</strong></li>
        <li>Yoğunluk veya ağır bir prompt durumunda bu süre 10 dakikaya kadar uzayabilir.</li>
        <li>Üretim sırasında sayfadan ayrılsanız bile süreç arka planda devam eder; video hazır olduğunda <em>Videolarım</em> bölümünde listelenir.</li>
        <li>Herhangi bir hata durumunda <strong>harcadığınız kredi otomatik olarak iade edilir</strong>.</li>
      </ul>

      <h2>3. Ödeme ve Fatura</h2>
      <ul>
        <li>Ödemeler <strong>iyzico</strong> altyapısı üzerinden Visa ve Mastercard logolu kartlarla gerçekleştirilir. Kart bilgileri sunucularımızda saklanmaz.</li>
        <li>Fatura, satın alma işleminden sonra kullanıcıya kayıtlı e-posta adresine PDF olarak iletilir.</li>
        <li>Kurumsal fatura talepleri için satın alma sırasında vergi dairesi ve VKN bilgilerinizi girmeniz yeterlidir.</li>
      </ul>

      <h2>4. Sorumluluk</h2>
      <p>
        Video içeriğindeki konum ve parsel bilgileri, kullanıcının girdiği ada/parsel bilgisine ve TKGM (Tapu ve Kadastro
        Genel Müdürlüğü) açık verilerine dayanır. ProSanalDrone, bu verilerin doğruluğundan birincil kaynak kadar sorumludur;
        bilgilerin doğruluğunu, kullanıcının ilgili tapu kayıtlarıyla teyit etmesi önerilir.
      </p>

      <h2>5. Destek</h2>
      <p>
        Teslimat ve hizmetle ilgili her türlü sorunuz için: <strong>destek@prosanaldrone.com</strong>
      </p>
    </LegalPage>
  );
}

export function KvkkPage() {
  return (
    <LegalPage title="KVKK Aydınlatma Metni">
      <p>
        6698 sayılı Kişisel Verilerin Korunması Kanunu ("<strong>KVKK</strong>") uyarınca, <strong>ProSanalDrone</strong>
        {" "}("<em>Veri Sorumlusu</em>") olarak, hizmetlerimizi sunarken işlemiş olduğumuz kişisel verilerinize ilişkin
        aydınlatma yükümlülüğümüzü aşağıdaki şekilde yerine getirmekteyiz.
      </p>

      <h2>1. İşlenen Kişisel Veriler</h2>
      <p>Platformumuzda aşağıdaki veri kategorilerini işlemekteyiz:</p>
      <ul>
        <li><strong>Kimlik ve İletişim Verileri:</strong> ad soyad, e-posta adresi, telefon numarası (ödeme için), TC kimlik numarası (fatura için zorunlu haller)</li>
        <li><strong>Hesap Verileri:</strong> şifre (bcrypt ile tek yönlü şifrelenmiş olarak), Google OAuth profil bilgisi (giriş yaparken), kredi bakiyesi, satın alma geçmişi</li>
        <li><strong>İçerik Verileri:</strong> yüklediğiniz firma logosu, kendi müzik dosyalarınız, girdiğiniz ada/parsel bilgileri, video üretim talepleri</li>
        <li><strong>Ödeme Verileri:</strong> fatura bilgileri (kart bilgileri <strong>sunucularımızda tutulmaz</strong>; iyzico tarafından işlenir)</li>
        <li><strong>Teknik Veriler:</strong> IP adresi, tarayıcı tipi, cihaz bilgisi, oturum çerezleri</li>
      </ul>

      <h2>2. Kişisel Verilerin İşlenme Amaçları</h2>
      <ul>
        <li>Üyelik hesabınızın oluşturulması ve kimlik doğrulaması</li>
        <li>Satın aldığınız kredi paketlerinin tanımlanması ve video üretim hizmetinin sunulması</li>
        <li>Ödeme işlemlerinin iyzico altyapısı üzerinden gerçekleştirilmesi ve fatura düzenlenmesi</li>
        <li>Mesafeli Sözleşmeler Yönetmeliği kapsamındaki yasal yükümlülüklerin yerine getirilmesi</li>
        <li>Hizmet kalitesinin artırılması, teknik destek sağlanması ve kullanıcı deneyiminin iyileştirilmesi</li>
        <li>Güvenlik, dolandırıcılık önleme ve kötüye kullanım tespiti</li>
      </ul>

      <h2>3. Hukuki Sebep</h2>
      <p>Kişisel verileriniz KVKK m. 5/2 kapsamında şu hukuki sebeplere dayanılarak işlenmektedir:</p>
      <ul>
        <li>Sözleşmenin kurulması ve ifası için zorunlu olması (m. 5/2-c)</li>
        <li>Veri sorumlusunun hukuki yükümlülüğünü yerine getirmesi için zorunlu olması — vergi, fatura, mesafeli satış (m. 5/2-ç)</li>
        <li>Veri sorumlusunun meşru menfaati için zorunlu olması — hizmet güvenliği, iyileştirme (m. 5/2-f)</li>
      </ul>

      <h2>4. Kişisel Verilerin Aktarıldığı Taraflar</h2>
      <ul>
        <li><strong>iyzico Ödeme Hizmetleri A.Ş.</strong> — ödeme işlemleri için zorunlu veriler</li>
        <li><strong>Emergent / Cloudflare altyapısı</strong> — hizmetin barındırılması ve CDN</li>
        <li><strong>Google Workspace</strong> — kullanıcı tercih ederse Google ile giriş yapıldığında (OAuth)</li>
        <li><strong>Yetkili kamu kurumları</strong> — yasal bir talep hâlinde ve yalnızca ilgili düzenleme kapsamında</li>
      </ul>

      <h2>5. Kişisel Verilerin Toplanma Yöntemi</h2>
      <p>
        Verileriniz; hesap oluştururken, ödeme yaparken, video üretim talebi gönderirken ve platforma giriş yaparken;
        otomatik veya kısmen otomatik yöntemlerle elektronik ortamda toplanmaktadır.
      </p>

      <h2>6. Haklarınız (KVKK m. 11)</h2>
      <p>Veri sahibi olarak aşağıdaki haklara sahipsiniz:</p>
      <ul>
        <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
        <li>İşlenen verilere ilişkin bilgi talep etme</li>
        <li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme</li>
        <li>Yurt içinde/yurt dışında aktarıldığı üçüncü kişileri bilme</li>
        <li>Verilerin eksik veya yanlış işlenmiş olması hâlinde düzeltilmesini isteme</li>
        <li>KVKK m. 7'de öngörülen şartlar çerçevesinde silinmesini veya yok edilmesini isteme</li>
        <li>Yapılan işlemlerin, aktarıldığı üçüncü kişilere bildirilmesini isteme</li>
        <li>Otomatik sistemler vasıtasıyla analiz sonucu aleyhinize bir sonuç ortaya çıkması durumunda itiraz etme</li>
        <li>Kanuna aykırı işleme sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme</li>
      </ul>

      <h2>7. Başvuru</h2>
      <p>
        Haklarınızı kullanmak için <strong>destek@prosanaldrone.com</strong> adresine kimlik tespitinizi sağlayacak bilgilerle
        birlikte başvurabilirsiniz. Başvurunuz en geç <strong>30 gün</strong> içinde ücretsiz olarak sonuçlandırılacaktır.
      </p>
    </LegalPage>
  );
}

export function CerezPolitikasiPage() {
  return (
    <LegalPage title="Çerez Politikası">
      <p>
        Bu Çerez Politikası, <strong>ProSanalDrone</strong> web sitesini ("<em>Platform</em>") ziyaret ettiğinizde
        cihazınıza yerleştirilen çerezler ve benzeri izleme teknolojileri hakkında bilgi vermek amacıyla hazırlanmıştır.
      </p>

      <h2>1. Çerez Nedir?</h2>
      <p>
        Çerez (cookie), bir web sitesini ziyaret ettiğinizde tarayıcınız tarafından bilgisayarınıza veya mobil cihazınıza
        kaydedilen küçük metin dosyalarıdır. Çerezler, sitenin düzgün çalışması, kullanıcı tercihlerinin hatırlanması ve
        hizmetlerin iyileştirilmesi için kullanılır.
      </p>

      <h2>2. Platformda Kullanılan Çerez Türleri</h2>

      <h3>Zorunlu (Teknik) Çerezler</h3>
      <ul>
        <li><code>session_token</code> — Oturum doğrulaması için (Emergent Google OAuth akışı sonrası)</li>
        <li><code>psd_token</code> — localStorage'da saklanan JWT doğrulama anahtarı</li>
        <li>Hizmetin temel işlevi için gereklidir; onay gerektirmez.</li>
      </ul>

      <h3>Performans / Analitik Çerezler</h3>
      <ul>
        <li><strong>PostHog</strong> — ürün analitiği (sayfa görüntülemeleri, hangi özellik kaç kez kullanılıyor)</li>
        <li>Anonimleştirilmiş veridir; kişisel kimliğinizi ifşa etmez.</li>
        <li>Reddedebilirsiniz — site çalışmaya devam eder, sadece analitik veri toplanmaz.</li>
      </ul>

      <h3>Üçüncü Taraf Çerezler</h3>
      <ul>
        <li><strong>iyzico</strong> — ödeme sayfasına yönlendirme sırasında kart doğrulama ve 3D Secure akışı için</li>
        <li><strong>Google Fonts</strong> — tipografi (Cabinet Grotesk + Manrope) servisi</li>
      </ul>

      <h2>3. Çerezleri Yönetme</h2>
      <p>
        Tarayıcı ayarlarınızdan çerezleri silebilir veya belirli siteler için engelleyebilirsiniz. Ancak zorunlu
        çerezleri reddetmeniz hâlinde Platformun bazı özellikleri (ör. oturum açma, satın alma) çalışmayabilir.
      </p>
      <ul>
        <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer" className="text-[#C29B62] hover:underline">Chrome</a></li>
        <li><a href="https://support.mozilla.org/tr/kb/cerezleri-silme-web-sitelerinin-bilgilerini-kaldirma" target="_blank" rel="noreferrer" className="text-[#C29B62] hover:underline">Firefox</a></li>
        <li><a href="https://support.apple.com/tr-tr/guide/safari/sfri11471/mac" target="_blank" rel="noreferrer" className="text-[#C29B62] hover:underline">Safari</a></li>
        <li><a href="https://support.microsoft.com/tr-tr/microsoft-edge/microsoft-edge-de-cerezleri-silin-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noreferrer" className="text-[#C29B62] hover:underline">Edge</a></li>
      </ul>

      <h2>4. Çerez Onayı</h2>
      <p>
        Platforma ilk girişinizde ekranın altında çıkan çerez bildirimine onay vererek veya platformu kullanmaya devam
        ederek çerez kullanımını kabul etmiş olursunuz. İstediğiniz zaman tarayıcı ayarlarınızdan değişiklik yapabilirsiniz.
      </p>

      <h2>5. İletişim</h2>
      <p>
        Çerez politikası ile ilgili sorularınız için: <strong>destek@prosanaldrone.com</strong>
      </p>
    </LegalPage>
  );
}
